import { ChangeDetectionStrategy, Component, DestroyRef, ElementRef, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppMenu } from './app.menu';
import { MenuService } from '../service/menu.service';
import { MenuItem } from 'primeng/api';

/** Barra lateral do layout: assina o menu ativo e o renderiza via app-menu. */
@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [AppMenu],
    template: ` <div class="layout-sidebar">
        @if (menuItems().length > 0) {
            <app-menu [model]="menuItems()"></app-menu>
        }
    </div>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppSidebar implements OnInit {
    readonly el = inject(ElementRef);
    private readonly menuService = inject(MenuService);
    private readonly destroyRef = inject(DestroyRef);

    /** Itens do menu ativo, atualizados pelo `MenuService`. */
    readonly menuItems = signal<MenuItem[]>([]);

    ngOnInit(): void {
        this.menuService.menuItems$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((items) => {
            this.menuItems.set(items);
        });
    }
}
